var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        { staticClass: "justify-content-center" },
        [
          _c(
            "b-col",
            { staticClass: "form-page px-md-5", attrs: { cols: "12" } },
            [
              _c(
                "b-row",
                { staticClass: "header align-items-center" },
                [
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c(
                      "h2",
                      { staticClass: "page-header" },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("dashboard.welcomeBack")) +
                            ",\n            "
                        ),
                        _c(
                          "router-link",
                          {
                            staticClass: "clickable text-primary",
                            attrs: { to: { name: "settings" } },
                          },
                          [
                            _vm._v(
                              "\n              " + _vm._s(_vm.clientName) + " "
                            ),
                          ]
                        ),
                        _vm._v(".\n          "),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("h6", { staticClass: "subtitle" }, [
                      _vm._v(_vm._s(_vm.$t("dashboard.onYourWay")) + "!"),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c(
                      "div",
                      { staticClass: "card", staticStyle: { width: "100%" } },
                      [
                        _c(
                          "ul",
                          { staticClass: "list-group list-group-flush" },
                          [
                            _c("li", { staticClass: "list-group-item" }, [
                              _c(
                                "h6",
                                {
                                  staticClass: "text-gray",
                                  staticStyle: { margin: "0" },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t(
                                          "dashboard.yourApplicationStatus"
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "li",
                              { staticClass: "list-group-item" },
                              [
                                _c(
                                  "b-row",
                                  { staticClass: "justify-content-center" },
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "11" } },
                                      [
                                        _c("application-status-progress-bar", {
                                          staticClass: "mt-3 mb-4",
                                          attrs: {
                                            "current-application-status":
                                              _vm.currentApplicationStatus,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { attrs: { cols: "12", lg: "8" } }, [
                    _c(
                      "div",
                      { staticClass: "card" },
                      [_c("clients-activity")],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      staticClass: "order-first order-lg-last",
                      attrs: { cols: "12", lg: "4" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "card", staticStyle: { width: "100%" } },
                        [_c("outstanding-documents")],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }